
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works",
      function () {
        return require("private-next-pages/works/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works"])
      });
    }
  